'use client';

import { usePulseTracker } from '@cineamo/pulse/react';
import { useEffect } from 'react';

type ShowingTagTrackerProps = {
    showingTagId: number;
};

export function ShowingTagTracker({ showingTagId }: ShowingTagTrackerProps) {
    const { track } = usePulseTracker();

    useEffect(() => {
        track({
            event_type: 'series_view',
            entity_type: 'showing_tag',
            entity_id: showingTagId,
            context: {
                page: 'specials_detail',
                referrer_page: 'specials_list',
                showing_tag_ids: [showingTagId]
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showingTagId]);

    return null;
}
